import INFTCollections from '../../models/INFTCollections'
import AngryBearsLogo from '../../../../assets/nft-logo/AngryBears.jpg'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'
import AngryBearsDetail from '../../nftFormats/AngryBears/Detail/AngryBearsDetail'

export const AngryBearsData: INFTCollections[] = [
  {
    id: 'AngryBears',
    tokenAddress: '0x4401F68c8047Df5E2f86d6AA0ba6fF9fa87a57d4',
    name: 'Angry Bears',
    cardFormat: GeneralCard,
    detailFormat: AngryBearsDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0xDA127bFec97DA1114c7dD3f43724b6BB4762a863',
    logo: AngryBearsLogo,
    website: 'https://angrybears.xyz/',
    twitter: 'AngryBearsAvax'
  }
]

export const AngryBearsCategoryData = {
  [AngryBearsData[0].tokenAddress.toLowerCase()]: AngryBearsData[0].category
}
